export default __webpack_public_path__ + "static/media/adidas-01.07619940.jpg";